import React from 'react';
import { Container, Spinner, Row, Button, Col, Form } from 'react-bootstrap';

import { withAuthorization } from '../Session';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import DateFnsUtils from '@date-io/date-fns';

import { PatchedPagination } from '../services/PatchedPagination.js';
import MaterialTable from 'material-table';
import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';

import ReactExport from 'react-export-excel';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


function getColumns() {
    let columns = [
        {
            title: 'Date',
            field: 'Date'
            
        },
        {
            title: 'ProductName',
            field: 'ProductName'
        },
        {
            title: 'SKU',
            field: 'GCSku',
        },
        {
            title: 'Total Issuance',
            field: 'Issuance',render: (row) => (
                <div>
                    <span>₹ </span>{parseFloat(row.Issuance).toFixed(2)}
                </div>
            ) 
        },
        {
            title: 'Total Discount Given,',
            field: 'Issuance',render: (row) => (
                <div>
                    <span>₹ </span>{parseFloat(row.Discount).toFixed(2)}
                </div>
            ) 
        },
        {
            title: 'Total Brand Discount',
            field: 'BrandDiscount',render: (row) => (
                <div>
                    <span>₹ </span>{parseFloat(row.BrandDiscount).toFixed(2)}
                </div>
            ) 
        },
        {
            title: 'Total IB Earning',
            field: 'IBEarning',
            width: "10%",
            render: (row) => (
                <div>
                    <span>₹ </span>{row.IBEarning?parseFloat(row.IBEarning).toFixed(2):0}
                </div>
            ) 
            
        }
        
    ];
    return columns;
}

class BrandwiseReportByDate extends React.Component {
    _isMounted = false;
    state = {
        alert: 0,
        alertMessage: '',
        data: [],
        selectedItem: [],
        flag: false,
        report_from_date:this.props.selectedReportDate?this.props.selectedReportDate:this.getFormattedDate(new Date()),
        report_to_date:this.props.selectedReportDate?this.props.selectedReportDate:this.getFormattedDate(new Date()),
        report_title:'',
        reportData:[],
        DownloadReady:false,
    
    };
    getFormattedDate(date) {
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var yyyy = date.getFullYear();

        date = yyyy + '-' + mm + '-' + dd;
        return date;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        if(this.props.selectedReportDate && this.props.selectedReportDate!=''){
            this.setState({
                flag: true,
                DownloadReady:false,
            });

            this.createReport()
        }
        
        this._isMounted = true;
    }
    
    
    createReport = async () => {
        if (this._isMounted) {
            this.setState({
                flag: true,
                DownloadReady:false,
            });
        }
        let bodyData = {
            fromDate:this.state.report_from_date,
            toDate:this.state.report_to_date,
            search_by: 'Date',
            moveTo: false,
            StartAt: [],
            LastDocument: false,
            FirstDocument: false,
            perPage: 10000000,
        };
         
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'giftcards/getMyBrandwiseReportGiftCards'
        )
            .then((response) => response.json())
            .then((responseData) => {
                var dataListArray =[]
                var dataList = responseData.list;
                if(dataList.length>0){
                        for (let i = 0; i < dataList.length; i++) {
                            dataListArray.push({
                                    Date:getFormattedDate(dataList[i].LastUpdated.substring(0,10)),
                                    BrandDiscount:dataList[i].BrandDiscount,
                                    Discount:dataList[i].Discount,
                                    GCSku:dataList[i].GCSku,
                                    ProductName:dataList[i].ProductName,
                                    IBEarning:dataList[i].IBEarning,
                                    Issuance:dataList[i].Issuance
                                });
                        }
                }

                if (this._isMounted) {
                    this.setState({
                        reportData: dataListArray,
                        alert: 0,
                        flag: false,
                        DownloadReady:true,
                    });
                }
                
            })
                
        
        }
        
         DownloadClose = () => {
                if (this._isMounted) {
                    this.setState({alert:2,alertMessage:'Report Downloaded...',selectedItem:[] });
                }
        };
        
            
    render() {
        
        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}
                <Row>
                    <h4
                        style={{
                            marginLeft: '1rem',
                            marginRight: '1rem'
                        }}
                    >
                        Brandwise Report
                    </h4>
                </Row>
                <div>
                    <hr />
                </div>
                
                    
                        <Row style={{marginTop: '1rem'}}>
                    <Col> 
                                <Form.Control
                                    placeholder="Enter report title"
                                    type="text"
                                    name="report_title"
                                    value={this.state.report_title}
                                    onChange={this.onChangeValues}
                                    required
                                />
                           </Col> 
                           <Col>
                        {!this.state.DownloadReady ?<Button variant="primary" onClick={this.createReport}>
                            Generate
                        </Button>:
                        <ExcelFile
                            element={
                                <Button variant="primary" onClick={this.DownloadClose}>
                                        Download Report
                                </Button>
                            }
                            filename={this.state.report_title}
                        >
                            <ExcelSheet
                                data={this.state.reportData}
                                name={this.state.report_title}
                            >
                                <ExcelColumn
                                    label="Date"
                                    value="Date"
                                />
                                <ExcelColumn
                                    label="Brand Name"
                                    value="ProductName"
                                />
                                <ExcelColumn
                                    label="Brand SKU"
                                    value="GCSku"
                                />
                                
                                <ExcelColumn
                                    label="Issuance Value"
                                    value="Issuance"
                                />
                                
                                <ExcelColumn
                                    label="Total Discount Given"
                                    value="Discount"
                                />
                                <ExcelColumn
                                    label="Total Brand Discount"
                                    value="BrandDiscount"
                                />
                                <ExcelColumn
                                    label="Total IB Earning"
                                    value="IBEarning"
                                />
                                
                                
                            </ExcelSheet>
                        </ExcelFile>}
                           </Col> 

                       </Row>
                       <div>
                            <hr />
                        </div>
                        
                       
                       {this.state.DownloadReady &&<MaterialTable
                            components={{
                                Pagination: PatchedPagination
                            }}
                            title="Summary"
                            columns={getColumns()}
                            data={this.state.reportData}
                            options={{
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1
                            }}
                        />}
            
            </Container>
        );
    }
}



const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(BrandwiseReportByDate);

